/**
 * @file HTTP Metric Attributes Builder
 * @description This module provides utility functions to build metric attributes
 * for HTTP requests and responses in OpenTelemetry.
 */

import { getEnvKey } from 'constants/envs';

/**
 * Builds attributes for HTTP response metrics.
 *
 * @param {string} url - The URL of the HTTP request.
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @param {number} status - The HTTP response status code.
 * @returns {Object} An object containing HTTP metric attributes.
 */
export const buildHttpResponseMetricAttributes = (url, method, status) => {
    const env = getEnvKey();

    return {
        'http.method': method,
        'http.url': url,
        'http.status_code': status,
        env,
        'host_name': window?.location?.hostname || 'unknown',
    };
};

/**
 * Builds attributes for the start of an HTTP request metric.
 *
 * @param {string} url - The URL of the HTTP request.
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @returns {Object} An object containing HTTP metric attributes.
 */
export const buildStartHttpRequestMetricAttributes = (url, method) => {
    const env = getEnvKey();

    return {
        'http.method': method,
        'http.url': url,
        env,
        'host_name': window?.location?.hostname || 'unknown',
    };
};
